export default __webpack_public_path__ + "static/media/ten.f78bd23b.png";